import { ClienteDTO } from "../interfaces/cliente.interface";
import { FacturaDTO } from "../interfaces/factura.interface";
import { RecepcionDTO } from "../interfaces/recepcion.interface";

export class OrdenCompraDTO {
    constructor(
        public idCliente: number,
        public fecha: string,
        public rutFacturar: string,
        public numero: string,
        public idOrdenesTrabajo: number[],
        public id?: number,
        public cliente?: ClienteDTO,
        public recepcion?: RecepcionDTO,
        public factura?: FacturaDTO,
        public valorTotal?: number,
        public tieneInforme?: boolean
        
    ) {
        this.idCliente = idCliente;
        this.fecha = fecha;
        this.rutFacturar = rutFacturar;
        this.numero = numero;
        this.idOrdenesTrabajo = idOrdenesTrabajo;
        this.id = id || null;
        this.cliente = cliente || null;
        this.recepcion = recepcion || null;
        this.factura = factura || null;
        this.valorTotal = valorTotal|| null;
        this.tieneInforme = tieneInforme|| false;
    }
}
